import { Card } from "react-bootstrap";
import CustomButton from "../../components/CustomButton/CustomButton";
import CustomTable from "../../components/CustomTable/CustomTable";
import AddEventCalendar from "./AddEventCalendar";
import { useEffect, useState } from "react";
import WebService from "../../utility/WebService";
import HelperService from "../../utility/HelperService";
import { PencilFill, TrashFill } from "react-bootstrap-icons";
import DeleteModal from "../../components/DeleteModal/DeleteModal";
import CustomTableSortable from "../../components/CustomTable/CustomTableSortable";

const EventCalendar = () => {
  const [showAddEvent, setShowAddEvent] = useState(false);
  const [events, setEvents] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [eventIdToDelete, setEventIdToDelete] = useState<string | null>(null);
  const [eventToEdit, setEventToEdit] = useState<any | null>(null);
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;


  const [sortField, setSortField] = useState<string>("createdAt");
  const [sortOrder, setSortOrder] = useState<"asc" | "desc">("desc");
  const [uiSortField, setUiSortField] = useState<string>("createdAtFormatted");

  const sortFieldMap: Record<string, string> = {
    name: "name",
    displayDate: "date",
    endDate: "endDate",
    location: "location",
    createdAtFormatted: "createdAt",
  }

  const [pagePermission, setPagePermission] = useState({
    canView: false,
    canAdd: false,
    canEdit: false,
    canDelete: false,
  });

  useEffect(() => {
    getEvents();
  }, [currentPage, sortField, sortOrder]);

  const getEvents = () => {
    const params = new URLSearchParams();

    params.append("page", currentPage.toString());
    params.append("limit", itemsPerPage.toString());
    params.append("sortField", sortField);
    params.append("sortOrder", sortOrder);
    WebService.getAPI({
      action: `event-calendar/list?${params.toString()}`,
    })
      .then((res: any) => {
        const perm = res?.data?.permissions || {};

        setPagePermission({
          canView: perm.canView,
          canAdd: perm.canAdd,
          canEdit: perm.canEdit,
          canDelete: perm.canDelete,
        });

        const updatedEvents = res?.data?.data?.map((event: any) => {
          return {
            ...event,                        // keep ORIGINAL date
            // displayDate: HelperService.dateFormatter(event.date), // formatted only for UI
            displayDate: HelperService.formatDateDDMMMYYYYShort(event.date),
            // endDate: event.endDate ? HelperService.dateFormatter(event.endDate) : "-",
            endDate: event.endDate ? HelperService.formatDateDDMMMYYYYShort(event.endDate) : "-",
            urlDisplay: event.url ? (
              <a href={event.url} target="_blank" rel="noopener noreferrer">
                {event.url}
              </a>
            ) : "-",
            action: (
              <div>
                {perm.canEdit && (
                  <PencilFill
                    className="me-3 cursor-pointer"
                    title="Edit"
                    onClick={() => {
                      setShowAddEvent(true);
                      setEventToEdit(event);  // pass FULL ORIGINAL event
                    }}
                  />
                )}

                {perm.canDelete && (
                  <TrashFill
                    color="#DC143C"
                    className="cursor-pointer"
                    title="Delete"
                    onClick={() => handleDeleteEvent(event._id)}
                  />
                )}
              </div>
            ),
          };
        });

        setEvents(updatedEvents);
        setTotalCount(res?.data?.pagination?.total);
      })
      .catch((err: any) => { });
  };

  const handleDeleteEvent = (eventId: string) => {
    setEventIdToDelete(eventId);
    setShowDeleteModal(true);
  };

  const handleReorder = (newRows: any) => {
    setEvents(newRows);
  };

  return (
    <>
      {/* Add/Edit Modal */}
      <AddEventCalendar
        show={showAddEvent}
        handleClose={() => {
          setShowAddEvent(false);
          setEventToEdit(null);
          getEvents();
        }}
        data={eventToEdit}
      />

      {/* Delete Modal */}
      <DeleteModal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        onDelete={() => {
          if (eventIdToDelete) {
            WebService.deleteAPI({
              action: `event-calendar/delete-calendar/${eventIdToDelete}`,
            }).then(() => {
              setShowDeleteModal(false);
              getEvents();
            });
          }
        }}
      />

      <div className="events-main">
        <Card className="event-card">
          <div className="d-flex justify-content-between">
            <div className="page-title">Event Calendar</div>

            {pagePermission.canAdd && (
              <CustomButton
                isLoading={false}
                label="Add"
                onClick={() => {
                  setEventToEdit(null);
                  setShowAddEvent(true);
                }}
                style={{ width: 100 }}
              />
            )}
          </div>

          <CustomTableSortable
            columns={[
              { id: "name", label: "Event Name", minWidth: 170, },
              { id: "displayDate", label: "Event Date", minWidth: 100, align: "center",sortable: true, }, // updated
              { id: "endDate", label: "End Date", minWidth: 100, align: "center",sortable: true, },
              { id: "location", label: "Location", minWidth: 100, align: "center", },
              { id: "urlDisplay", label: "URL", minWidth: 150, align: "center", },
              { id: "action", label: "Action", minWidth: 100, align: "center", },
            ]}
            rows={events}
            totalCount={totalCount}
            currentPage={currentPage}
            pageSize={itemsPerPage}
            onPageChange={(page) => {
              setCurrentPage(page);
            }}
            sortField={uiSortField}
            sortOrder={sortOrder}
            onSortChange={(columnId, order) => {
              console.log("SORT CLICKED:", columnId, order); 
              setUiSortField(columnId);
              setSortOrder(order);

              const apiField = sortFieldMap[columnId] || "createdAt";
              setSortField(apiField);

              setCurrentPage(1);
              // getEvents();
            }}
            draggable
            onRowsReorder={handleReorder}
          />
        </Card>
      </div>
    </>
  );
};

export default EventCalendar;
